export default __webpack_public_path__ + "static/error-655fea8070800475032643f7db3d8adf.png";